import { partnerPage } from 'utils/pageTemplates/partnerPage';

const { getStaticProps, getStaticPaths, PartnerPageComponent } = partnerPage();

export { getStaticPaths, getStaticProps };
export default PartnerPageComponent;
